import { c as _c } from "react/compiler-runtime";
import { FaroTable } from "@components/common/faro-table/faro-table";
import { useAnalyticsProjectsBreakdownColumns } from "@components/analytics/in-house/hooks/use-analytics-projects-breakdown-columns";
import { TableType } from "@utils/track-event/track-event-list";
import { ANALYTICS_TABLE_COLUMN_LABELS, METRIC_CHART_METADATA } from "@components/analytics/in-house/constants/analytics-constants";
import { FaroTableColumnVisibilityMenu } from "@components/common/faro-table/faro-table-column-visibility-menu";
import { useHandleColumnOrderChange } from "@hooks/use-handle-column-order-change";
import { useMemo } from "react";
/** Renders the in-house analytics projects breakdown table. */
export function AnalyticsTable(t0) {
  const $ = _c(12);
  const {
    projects,
    isLoading,
    selectedMetricKey
  } = t0;
  const columns = useAnalyticsProjectsBreakdownColumns(selectedMetricKey);
  const t1 = METRIC_CHART_METADATA[selectedMetricKey];
  let t2;
  if ($[0] !== t1.tableColumnLabel) {
    t2 = {
      ...ANALYTICS_TABLE_COLUMN_LABELS,
      totalViews: t1.tableColumnLabel
    };
    $[0] = t1.tableColumnLabel;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const labelsMap = t2;
  const handleColumnOrderChange = useHandleColumnOrderChange(TableType.analyticsProjects, false);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["projectName"];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== labelsMap) {
    t4 = <FaroTableColumnVisibilityMenu labelsMap={labelsMap} disabledColumns={t3} tableType={TableType.analyticsProjects} />;
    $[3] = labelsMap;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      "& .MuiDataGrid-columnHeader:hover .drag-handle": {
        display: "flex"
      },
      "& .MuiDataGrid-columnHeaderTitleContainerContent": {
        width: "100%"
      }
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== columns || $[7] !== handleColumnOrderChange || $[8] !== isLoading || $[9] !== projects || $[10] !== t4) {
    t6 = <FaroTable entities={projects} uniqueIdKey="projectId" isLoading={isLoading} shouldHideCheckbox={true} shouldSkipDynamicHeight={true} columns={columns} rowHeight={70} tableType={TableType.analyticsProjects} filterMenuTrigger={t4} onColumnOrderChange={handleColumnOrderChange} sx={t5} />;
    $[6] = columns;
    $[7] = handleColumnOrderChange;
    $[8] = isLoading;
    $[9] = projects;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}